/** Tab-local operation/row identities, not authentication tokens. Works without secure-context-only randomUUID. */
export function createIdentity(): string {
  return `job-${Array.from(crypto.getRandomValues(new Uint8Array(16)), n => n.toString(16).padStart(2, '0')).join('')}`;
}
